import {useParams} from 'react-router-dom';

import {Grid} from '@mantine/core';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';
import {InvoicePreview} from '../profile/InvoicePreview';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useInvoice} from '../hooks/useInvoice';
import {useEditPageTools} from '../hooks/useEditPageTools';
import {FormDrawer} from '../drawers/FormDrawer';

export const EditPage = () => {

    const {id: componentId} = useParams();

    if (typeof componentId === 'undefined') {
        throw new Error('componentId is required parameter');
    }

    const {
        record: component,
        loading,
        updateRecord,
    } = useInvoice(componentId);

    const {
        drawerOpened,
        setDrawerOpened,
        tools,
    } = useEditPageTools();

    if (loading || !component) {
        return <PlatformLoader message='Loading application...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={component.number ? component.number : component.id}
            pageNavigation={<EditPageNavigation component={component}/>}
            tools={tools}
        >

            <Grid>
                <Grid.Col span={{
                    base: 12,
                    lg: 4
                }}>
                    <Profile record={component}/>
                </Grid.Col>
                <Grid.Col span={{
                    base: 12,
                    lg: 8
                }}>
                    <InvoicePreview record={component}/>
                </Grid.Col>
            </Grid>

            <FormDrawer
                record={component}
                handleSubmit={updateRecord}
                opened={drawerOpened}
                onClose={() => setDrawerOpened(false)}
            />

        </FormPageLayout>
    );
};
